import React from 'react';
import dayjs from 'dayjs';
// en is included by default
import 'dayjs/locale/es';
import Translation from '@athena/spark/icons/Translation';
import { useTranslation } from 'react-i18next';
import { ampGlobalProps } from 'src/lib/amplitude';
import useIsMobile from 'src/lib/hooks/useIsMobile';
import { AmplitudeButton } from '../AmplitudeButton';
import styles from './LanguageButton.module.scss';

const LanguageButton = () => {
  const { t, i18n } = useTranslation();
  const isMobile = useIsMobile();
  document.getElementsByTagName('html')[0].setAttribute('lang', i18n.language);
  document.getElementsByTagName('html')[0].setAttribute('xml:lang', i18n.language);

  const toLang = i18n.language === 'es' ? 'en' : 'es';

  const handleOnClick = () => {
    i18n.changeLanguage(toLang);
    dayjs.locale(i18n.language);
    ampGlobalProps['Common::DefaultLanguage'] = i18n.language;
  };

  return (
    <AmplitudeButton
      action="SwitchLangCTA"
      eventProperties={{ 'Common::ToLang': toLang === 'es' ? 'Spanish' : 'English' }}
      pageNameInProps={true}
      onClick={handleOnClick}
      className={styles.languageButton}
      variant="text"
      icon={<Translation className={styles.translationIcon} />}
      lang={i18n.language === 'es' ? 'en' : 'es'}
    >
      {isMobile ? t('LANGUAGE_BUTTON_SHORT') : t('LANGUAGE_BUTTON')}
    </AmplitudeButton>
  );
};

export default LanguageButton;
